<template>
  <div class="web-box-all">
    <ext-header></ext-header>

    <div class="web-home-main">

      <div class="web-order-state">
        <ul>
            <li>
                <p></p>
                <a>1.我的购物车</a>
                <b>1</b>
            </li>
            <li>
                <p class="order-state-ok"></p>
                <a class="order-font-ok">2.填写核对订单信息</a>
                <b class="order-state-ok">2</b>
            </li>
            <li>
                <p class="order-state-last"></p>
                <a class="order-font-last">3.成功提交订单</a>
                <b class="order-state-last">3</b>
            </li>
        </ul>
      </div>

      <div class="web-order-main">

        <div class="web-order-address">
            <h2>餐厅名称：{{user_info.store_name}}</h2>
            <ul>
                <li v-if="user_info.market_name">
                    <p>所属市场：{{user_info.market_name}}</p>
                </li>
                <li v-if="user_info.store_no">
                    <p>门店编号：{{user_info.store_no}}</p>
                </li>
                <li v-if="user_info.zoneNo">
                    <p>国际编码：{{user_info.zoneNo}}</p>
                </li>
                <li v-if="user_info.store_phone">
                    <p>餐厅电话：{{user_info.store_phone}}</p>
                </li>
                <li v-if="user_info.user_phone">
                    <p>联系电话：{{user_info.user_phone}}</p>
                </li>
                <li v-if="user_info.store_address">
                    <p>餐厅地址：{{user_info.store_address}}</p>
                </li>
            </ul>
            <p>{{ tip_msg }}</p>
        </div>

        <div class="web-address-list">
          <h2>请选择餐厅地址</h2>
          <ul>
            <li v-for="(vo,index) in store_address" :key="index"  :class="[vo.store_no==select_store_no ? 'select' : '']" @click="set_address(vo.store_no)">
              <h2>餐厅名称：{{vo.store_name}} （{{vo.store_no}}） <span style="margin-left:20px;">{{vo.store_phone}}</span></h2>
              <p>餐厅地址：{{vo.store_address}}</p>
              <a><b-icon icon="check2-circle" aria-hidden="true"></b-icon></a>
            </li>
          </ul>
        </div>

        <div class="web-order-address-line"></div>

        <div class="web-order-info-title" v-if="company_no=='MCD-CHN'">
            <h2>发货方式</h2>
            <p>
                <b-form-radio-group v-model="delivery_way" :options="delivery_list" style="margin-right:20px; cursor: pointer;"></b-form-radio-group>
            </p>
        </div>

        <div class="web-order-info-title" v-if="company_no=='MCD-CHN'">
            <h2>购物积分<span>（当前剩余购物积分：{{user_info.integral}}，这个订单最多能抵扣金额：￥{{deduction_max_fee}}）</span></h2>
            <div class="web-order-info-integral">
                <div class="web-order-info-integral-input">
                    <input type="number" v-model="deduction_fee" @blur.capture="deduction_input" placeholder="请输入抵扣金额"/>
                </div>
                <div class="web-order-info-integral-button">
                    <p @click="set_deduction_fee()">确认兑换</p>
                </div>
            </div>
        </div>

        <div class="web-order-info-title">
            <h2>订单备注</h2>
            <b-form-textarea
                id="textarea"
                v-model="order_remark"
                placeholder="请输入订单备注.."
                rows="3"
                max-rows="6"
            ></b-form-textarea>
        </div>

        <div class="web-order-info-title" style="border:0px;">
            <h2>商品清单</h2>
        </div>

        <div class="web-order-goods-box">

            <div v-for="(vo,index) in cart_list" :key="index" class="web-cart-list-data">
                <div class="web-cart-list-checkbox">
                    <img @click="get_goods_show(vo.goods_no)" src="@/assets/goods_load.png" v-real-img="web_url+vo.goods_image">
                </div>
                <div class="web-cart-list-goods">
                    <p>{{vo.goods_name}}</p>
                    <a>{{vo.goods_no}}</a>
                </div>
                <div class="web-cart-list-props">
                  <p>{{vo.goods_activity}}</p>
                </div>
                <div class="web-cart-list-price">
                   <p>￥{{vo.goods_money}}</p>
                </div>
                <div class="web-cart-list-quantity">
                    <p>
                    <a @click="cart_del(index)">-</a>
                    <input type="number" v-model.number="vo.qty" :data-index="index" @blur.capture="input_out"/>
                    <a @click="cart_add(index)">+</a>
                    </p>
                </div>
            </div>

        </div>

        <div class="web-order-info-title" style="border:0px;">
            <h2>请选择支付方式</h2>
        </div>
        <div class="web-pay-select-box">
            <ul>
              <li v-if="shop_type != '1' " @click="select_pay_type(1)" :class="pay_type=='1' ? 'select' : ''">
                <img src="@/assets/icon/pay01.png">
                <p>月结支付</p>
              </li>
              <li v-if="shop_type == '1'" @click="select_pay_type(2)" :class="pay_type=='2' ? 'select' : ''">
                <img src="@/assets/icon/qrpay.png">
                <p>在线支付</p>
              </li>
              <li v-if="shop_type == '1' " @click="select_pay_type(5)" :class="pay_type=='5' ? 'select' : ''">
                <img src="@/assets/icon/home_bg.png">
                <p>公账支付</p>
              </li>
            </ul>
        </div>

      </div>

      <div class="web-order-footer">
        <ul>
            <li>
                <p>配送方式：</p>
                <a>
                  <b-form-select v-model="logistics_id" :options="logistics_select" @change="event_logistics" value-field="value" text-field="text" disabled-field="请选择配送方式" style="padding:3px;"></b-form-select>
                </a>
            </li>
            <li>
                <p>商品合计：</p>
                <a>￥{{sum_goods_money}}</a>
            </li>
            <li v-if="company_no=='MCD-CHN'">
                <p>优惠金额：</p>
                <a>-￥{{coupon_fee}}</a>
            </li>
            <li v-if="company_no=='MCD-CHN'">
                <p>抵扣金额：</p>
                <a>-￥{{ok_deduction_fee}}</a>
            </li>
            <li v-if="company_no=='MCD-CHN'">
                <p>消费积分：</p>
                <a>{{pay_integral}}<span> (积分商品)</span></a>
            </li>
        </ul>
        <ul class="money">
            <li>
                <p>订单金额：</p>
                <a class="red">{{pay_money}}</a>
            </li>
           <li>
                <a><span class="select">订单运费：{{logistics_fee}}</span></a>
            </li>
        </ul>
        <h2>
            <a v-if="company_no=='SUB-CHN'" id="post_data" @click="submit_sub_order()">提交订单</a>
            <a v-else id="post_data" @click="submit_order()">提交订单</a>
        </h2>
      </div>

    </div>

    <div class="web-home-line"></div>

    <ext-footer></ext-footer>

    <b-modal id="bv-modal-order-tip" centered  hide-footer>
      <template #modal-title>
        提示
      </template>
      <div class="d-block text-center">
        <h6>{{order_message}}</h6>
      </div>
      <div class="web-modal-foot">
        <a @click="$bvModal.hide('bv-modal-order-tip')" class="no">取消</a>
        <a @click="ok_exchange();$bvModal.hide('bv-modal-order-tip')" class="ok">确定兑换</a>
      </div>
    </b-modal>

    <b-modal id="sub-modal-order-tip" centered  hide-footer>
      <template #modal-title>
        温馨提示
      </template>
      <div class="d-block text-center">
        <h6 style="text-align: left;">请核对商品信息和地址信息，因买方订购错误造成的退货和换货需要买方承担相关退换货运费。</h6>
      </div>
      <div class="web-modal-foot">
        <a @click="$bvModal.hide('sub-modal-order-tip')" class="no">继续检查</a>
        <a @click="submit_order();$bvModal.hide('sub-modal-order-tip')" class="ok">确认付款</a>
      </div>
    </b-modal>

    <b-modal id="all-order-tip" centered hide-footer>
      <template #modal-title @click="goOrderList()">
        温馨提示
      </template>
      <div class="d-block text-center">
        <h6 style="text-align: left;">{{all_tip_msg}}</h6>
      </div>
      <div class="web-modal-foot">
        <a @click="$bvModal.hide('all-order-tip');goOrderList()" class="no">确认</a>
      </div>
    </b-modal>

    <ext-toast :style="toast_state" :toast_text="toast_text"></ext-toast>

  </div>
</template>
<script>
import ExtHeader from '@/components/header/index'
import ExtFooter from '@/components/footer/index'
import {getUserId, ajax, Encrypt, Decrypt, webUrl, getCompanyNo} from '@/utils/extend'
import $ from 'jquery'
import qs from 'qs'
import Toast from '@/components/toast/index'

export default {
  name: 'order_submit',
  components: {
    'ext-header': ExtHeader,
    'ext-footer': ExtFooter,
    'ext-toast': Toast
  },
  data () {
    return {
      title: '立即购买',
      web_url: webUrl(),
      company_no: getCompanyNo(),
      user_info: {},
      delivery_way: '0',
      delivery_list: [{
        value: '1',
        text: '齐货发'
      }, {
        value: '2',
        text: '有货先发'
      }],
      order_message: '',
      order_remark: '',
      cart_ids: '',
      cart_type: '1',
      cart_list: [],
      pay_type: '1',
      shop_type: '0',
      logistics_list: [],
      logistics_select: [],
      coupon_list: [],
      pay_integral: 0,
      sum_goods_money: 0,
      pay_money: '请选择配送方式',
      up_pay_state: false,
      deduction_fee: 0,
      ok_deduction_fee: '0.00',
      coupon_id: '',
      coupon_name: '请选择',
      coupon_fee: '0.00',
      logistics_id: '',
      logistics_name: '请选择',
      logistics_fee: '不含运费',
      deduction_max_fee: 0,
      toast_state: 'display:none',
      toast_text: '',
      tip_msg: '',
      store_address: [],
      select_store_no: '',
      all_tip_msg: ''
    }
  },
  mounted () {
    var params = this.$route.query
    var selectIds = Decrypt(params.v)

    if (params.type_id) {
      this.cart_type = params.type_id
    }

    if (selectIds) {
      this.cart_ids = selectIds
      this.load_user()

      this.load_order_info()
    } else {
      this.$router.push({path: '/cart/cart_list', query: {}})
    }

    this.get_tip_msg()
    this.load_address()
  },
  methods: {
    toast (msg) {
      var that = this
      that.toast_state = 'display:block'
      that.toast_text = msg
      setTimeout(function () {
        that.toast_text = ''
        that.toast_state = 'display:none'
      }, 3000)
    },
    set_address (storeNo) {
      var that = this
      that.select_store_no = storeNo
      that.up_pay_money()
    },
    load_address () {
      var that = this

      ajax({
        url: '/store/user/store_address',
        method: 'post',
        data: {
          uid: getUserId()
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          that.select_store_no = ret.data[0].store_no
          that.store_address = ret.data
        }
      })
    },
    get_logistics_type (index) {
      this.logistics_id = this.logistics_list[index].id
      this.logistics_name = this.logistics_list[index].name
    },
    event_logistics () {
      this.up_pay_money()
    },
    numFilter (value) {
      var realVal = parseFloat(value).toFixed(2)
      return realVal
    },
    input_out (e) {
      var input = e.target._value
      var index = e.target.dataset['index']
      if (input) {
        var goodsNo = this.cart_list[index].goods_no
        this.$set(this.cart_list[index], 'qty', input)
        this.updata_cart_qty(goodsNo, input)
      }
    },
    get_tip_msg () {
      var that = this
      ajax({
        url: '/store/order/get_tip_msg',
        method: 'post',
        data: {
          uid: getUserId()
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          if (ret.data) {
            that.tip_msg = ret.data
            that.toast(ret.data)
          }
        }
      })
    },
    deduction_input (e) {
      var that = this
      var input = e.target._value
      if (input) {
        var deductionMaxFee = this.deduction_max_fee

        var reg = /^(?!0+(?:\.0+)?$)(?:[1-9]\d*|0)(?:\.\d{1,2})?$/
        var isNum = new RegExp(reg)
        if (isNum.test(input)) {
          var getInput = parseFloat(input).toFixed(2)
          var getDeduction = parseFloat(deductionMaxFee).toFixed(2)
          if ((getInput - getDeduction) > 0) {
            that.toast('这个订单最多能抵扣金额' + deductionMaxFee + '元')
            that.deduction_fee = ''
          } else {
            that.deduction_fee = input
          }
        } else {
          that.deduction_fee = 0
        }
      } else {
        that.deduction_fee = 0
      }
    },
    set_deduction_fee () {
      this.ok_deduction_fee = this.deduction_fee
      this.pay_integral = this.deduction_fee * 100
      if (this.deduction_fee > 0) {
        this.up_pay_money()
        this.toast('兑换成功，请继续下单')
      } else {
        this.up_pay_money()
        this.toast('兑换成功，请继续下单')
      }
    },
    select_pay_type (str) {
      this.pay_type = str
    },
    cart_del (index) {
      var setQty = 0
      var qty = this.cart_list[index].qty
      if (qty > 1) {
        this.cart_list[index].qty = parseInt(qty) - 1
        setQty = parseInt(qty) - 1
      } else {
        this.cart_list[index].qty = 1
        setQty = 1
      }
      var goodsNo = this.cart_list[index].goods_no

      this.ok_deduction_fee = 0
      this.deduction_fee = 0

      this.updata_cart_qty(goodsNo, setQty)
    },
    cart_add (index) {
      var setQty = 0
      var qty = this.cart_list[index].qty
      this.cart_list[index].qty = parseInt(qty) + 1
      var goodsNo = this.cart_list[index].goods_no
      setQty = parseInt(qty) + 1
      this.updata_cart_qty(goodsNo, setQty)
    },
    updata_cart_qty (goodsNo, qty) {
      var that = this

      ajax({
        url: '/store/order/add_cart',
        method: 'post',
        data: {
          uid: getUserId(),
          type_id: that.cart_type,
          goods_no: goodsNo,
          qty: qty
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          that.up_coupon_info()
        }
      })
    },
    load_order_info () {
      var that = this
      var cartIds = this.cart_ids

      let loading = this.$loading({
        lock: true,
        text: '正在连接，请稍等',
        background: 'rgba(0,0,0,0.5)'
      })

      ajax({
        url: '/store/order/order_info_json',
        method: 'post',
        data: {
          uid: getUserId(),
          cart_ids: cartIds
        }
      }, function (ret) {
        loading.close()
        if (ret && ret.code === 'success') {
          that.logistics_list = ret.data.logistics_list

          var ListArr = []
          var list = ret.data.logistics_list
          list.forEach(function (val) {
            ListArr.push({
              'value': val.id,
              'text': val.name
            })
          })
          that.logistics_select = ListArr

          if (ret.data.logistics_list.length) {
            that.logistics_id = ret.data.logistics_list[0].id
            that.logistics_name = ret.data.logistics_list[0].name
            that.up_coupon_info()
          }

          that.load_goods()

          // 弹窗自动兑换剩余积分
          setTimeout(function () {
            if (that.deduction_max_fee > 0) {
              that.order_message = '您的积分最多能抵扣金额：¥ ' + that.deduction_max_fee
              that.$bvModal.show('bv-modal-order-tip')
            }
          }, 2000)
        } else {
          that.cart_list = []
        }
      })
    },
    ok_exchange () {
      var that = this
      that.ok_deduction_fee = that.deduction_max_fee
      that.deduction_fee = that.deduction_max_fee
      that.pay_integral = that.deduction_max_fee * 100
      if (that.deduction_fee > 0) {
        that.up_pay_money()
        that.toast('兑换成功，请继续下单', 2000)
      }
    },
    up_coupon_info () {
      var that = this
      var cartIds = this.cart_ids
      var cartType = this.cart_type

      ajax({
        url: '/store/order/up_coupon_info',
        method: 'post',
        data: {
          uid: getUserId(),
          cart_ids: cartIds,
          cart_type: cartType
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          var couponList = ret.data.coupon_list

          if (couponList.length > 0) {
            that.coupon_list = couponList
            that.coupon_id = couponList['0']['id']
            that.coupon_name = couponList['0']['name']
            that.coupon_fee = couponList['0']['coupon_fee']
          }

          that.up_pay_money()
        } else {
          that.coupon_list = []
          that.coupon_id = ''
          that.coupon_name = ''
          that.coupon_fee = '0.00'
          that.up_pay_money()
        }
      })
    },
    up_pay_money () {
      var that = this
      var cartIds = this.cart_ids
      var logisticsId = this.logistics_id
      var couponId = this.coupon_id
      var deductionFee = this.ok_deduction_fee
      var cartType = this.cart_type

      if (logisticsId === '0') {
        return false
      }

      // that.toast('正在加载中,正在计算运费..')

      ajax({
        url: '/store/order/up_pay_money',
        method: 'post',
        data: {
          uid: getUserId(),
          cart_ids: cartIds,
          goods_no: '',
          goods_qty: '',
          cart_type: cartType,
          logistics_id: logisticsId,
          coupon_id: couponId,
          deduction_fee: deductionFee
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          that.up_pay_state = true
          that.pay_money = '¥' + ret.data.pay_money
          that.logistics_fee = ret.data.logistics_fee

          that.sum_goods_money = ret.data.sum_goods_money
          that.deduction_max_fee = ret.data.deduction_max_fee
          // that.pay_integral = ret.data.pay_integral

          if (getCompanyNo() === 'MCD-CHN') {
            if (ret.data.delivery_way === '1') {
              that.set_delivery_way(1)
            }
          } else {
            that.set_delivery_way(2)
          }
        } else {
          that.up_pay_state = false
          that.sum_goods_money = 0
          that.deduction_max_fee = 0
          that.pay_money = '-'
          that.pay_integral = 0
          that.logistics_fee = '不含运费'
        }
      })
    },
    set_delivery_way (id) {
      if (id) {
        this.delivery_way = '' + id
      }
    },
    get_goods_show (goodsNo) {
      this.$router.push({path: '/goods/goods_show', query: {v: Encrypt(goodsNo)}})
    },
    load_user () {
      var that = this
      ajax({
        url: '/store/user/user_json',
        method: 'post',
        data: {
          uid: getUserId()
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          that.user_info = ret.data
          if (ret.data.shop_type === '1') {
            that.shop_type = '1'
            that.pay_type = 5
          } else {
            that.shop_type = '0'
            that.pay_type = 1
          }
        }
      })
    },
    load_goods () {
      var that = this
      var cartIds = this.cart_ids
      var cartType = this.cart_type
      ajax({
        url: '/store/order/user_cart_select',
        method: 'post',
        data: {
          uid: getUserId(),
          cart_type: cartType,
          cart_ids: cartIds
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          that.cart_list = ret.data.list
        }
      })
    },
    verify_post (type) {
      if (type === true) {
        $('#post_data').css({'background': '#cccccc'})
      } else {
        $('#post_data').css({'background': '#d81e06'})
      }
    },
    submit_sub_order () {
      this.$bvModal.show('sub-modal-order-tip')
    },
    goOrderList () {
      this.$router.push({path: '/order/order_list', query: {}})
    },
    verify_order_goods (payType, orderNo) {
      var that = this
      ajax({
        url: '/store/api/verify_order_goods',
        method: 'post',
        data: qs.stringify({
          uid: getUserId(),
          order_no: orderNo
        })
      }, function (ret) {
        if (ret) {
          if (ret.code === 'success') {
            that.toast(ret.msg)
            if (payType === '2') {
              setTimeout(function () {
                that.$router.push({path: '/cart/pay_order', query: {v: Encrypt(orderNo)}})
              }, 2000)
            } else {
              setTimeout(function () {
                that.$router.push({path: '/order/order_list', query: {}})
              }, 2000)
            }
          } else {
            that.all_tip_msg = ret.msg
            that.$bvModal.show('all-order-tip')
          }
        }
      })
    },
    submit_order () {
      var that = this
      // var payType = this.pay_type
      var deliveryWay = this.delivery_way

      var cartType = this.cart_type
      if (deliveryWay === '1' || deliveryWay === '2') {
        this.pay_win_state = 0
        if (this.up_pay_state === false) {
          return false
        }
        that.up_pay_state = false

        that.verify_post(true)

        let loading = this.$loading({
          lock: true,
          text: '提交中，请稍等',
          background: 'rgba(0,0,0,0.5)'
        })

        ajax({
          url: '/store/order/submit_order',
          method: 'post',
          data: qs.stringify({
            uid: getUserId(),
            order_source: 'web',
            delivery_way: deliveryWay,
            order_remark: that.order_remark,
            coupon_id: that.coupon_id,
            logistics_id: that.logistics_id,
            deduction_fee: that.deduction_fee,
            pay_type: that.pay_type,
            cart_type: cartType,
            cart_ids: that.cart_ids,
            select_store_no: that.select_store_no
          })
        }, function (ret) {
          loading.close()
          that.verify_post(false)
          if (ret && ret.code === 'success') {
            that.toast(ret.msg)
            setTimeout(function () {
              if (that.pay_type === 2) {
                that.verify_order_goods(that.pay_type, ret.data.order_no)
              } else if (that.pay_type === 5) {
                that.verify_order_goods(that.pay_type, ret.data.order_no)
              } else {
                that.up_pay_state = true
                that.$router.push({path: '/order/order_list', query: {}})
              }
            }, 2000)
          } else {
            that.up_pay_state = true
            that.toast(ret.msg)
          }
        })
      } else {
        that.toast('请选择发货方式')
        return false
      }
    }
  }
}
</script>
<style scoped>
header,section,footer,div,ul,ol,li,img,a,span,em,del,legend,center,strong,var,fieldset,form,label,dl,dt,dd,cite,input,hr,time,mark,code,figcaption,figure,textarea,h1,h2,h3,h4,h5,h6,p{
    display:-moz-box;
    display: box;
    display: -webkit-box;
    font-family: "Noto Sans SC";
    display: inline-flex;
}

a { text-decoration:none; }
input { box-sizing:border-box;outline:none;}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {-webkit-appearance: none;}
input[type='number'] {-moz-appearance: textfield;}
.web-box-all { width:100%; height:auto; flex-wrap:wrap; align-content:flex-start;}
.web-home-main { width:1000px; height:auto; margin:0px auto; flex-wrap:wrap; align-content:flex-start;}
.web-home-line { width:100%; height:70px; }

.web-order-state { width:100%; height:50px;}
    .web-order-state ul { width:800px; height:50px; margin:20px 0px 0px  100px; list-style:none; padding:0px;}
    .web-order-state ul li { width:266px; height:50px; position: relative; list-style:none; margin:0px; padding:0px;}
    .web-order-state ul li p { width:100%; height:5px; background: #caecb6; margin-top:15px;}
    .web-order-state ul li a { width: 100%; height:20px; position: absolute; text-align: center; justify-content:center; left:0px;  top:25px; line-height:20px; font-size:14px; color:#caecb6;}
    .web-order-state ul li a:hover { color:#caecb6;}
    .web-order-state ul li b { width:20px; height: 20px; position: absolute; left:50%; margin-left:-10px;  top:5px; font-size:14px; color:#ffffff; background: #caecb6; border-radius: 45px; text-align: center;}
    .order-state-ok { background: #7abd54 !important; color:#ffffff !important}
    .order-state-last { background: #cccccc !important; color:#ffffff !important;}
    .order-font-ok { color: #7abd54 !important;}
    .order-font-last { color: #cccccc !important;}

.web-order-main { width:100%; height:auto; padding:20px; margin-top:30px; border:1px solid #dfdfdf; flex-wrap:wrap; align-content:flex-start;}
    .web-order-address { width:100%; height:auto; flex-wrap:wrap; align-content:flex-start;}
    .web-order-address h2 { width:100%; height:30px; line-height:30px; font-size:14px; font-weight: bold; margin:0px; padding:0px; color:#333333;}
    .web-order-address ul { width:100%; height:auto; list-style:none; margin:0px; padding:0px; display: flex; flex-flow:row; align-content:flex-start; flex-wrap:wrap;}
    .web-order-address ul li { width:50%; height:30px; margin:0px; padding:0px;}
    .web-order-address ul li p { width:100%; height:30px; margin:0px; padding:0px; line-height:30px; font-size:14px; color:#333333;}
    .web-order-address-line { width:100%; height:5px; margin-top:15px; background-size: auto 100%; background-image:url('../../assets/icon/order_address_line.png'); background-repeat : repeat-x;}
    .web-order-address p { width:100%; height:20px; line-height:20px; font-size:14px; color:#d81e06;}
.web-order-info-title { width:100%; height:auto; margin-top:10px; border-bottom: 1px solid #dfdfdf; flex-wrap:wrap; align-content:flex-start;}
    .web-order-info-title h2 { width:100%; height:30px; line-height:30px; font-size:14px; font-weight: bold; margin:0px; padding:0px; color:#333333;}
    .web-order-info-title p { width:100%; height:30px; line-height:30px; font-size:14px; }
    .web-order-info-title p div.custom-radio { cursor: pointer;}
    .web-order-info-title h2 span { font-size:14px; color:#666666; font-weight: normal; margin-left:20px;}

    .web-order-info-integral { width:100%; height: 50px; margin-top:10px;}
        .web-order-info-integral-input { width:200px; height: 30px; border:1px solid #dfdfdf;}
            .web-order-info-integral-input input { width:190px; height:20px; border:0px; margin-top:5px; line-height:20px; font-size:14px; padding:0px 15px;}
        .web-order-info-integral-button { width:100px; height:30px; border:1px solid #d81e06; margin-left:10px;}
            .web-order-info-integral-button p { width:100px; cursor: pointer; height:30px;  text-align: center; line-height: 30px; justify-content:center; font-size:14px; color:#d81e06;}
  .web-cart-list-data { width:100%; height:auto; margin-top:0px; border-left:1px solid #dfdfdf; border-bottom:1px solid #dfdfdf; border-right:1px solid #dfdfdf;}
 .web-cart-list-goods { width:210px; height:auto; line-height:40px; font-size:14px; flex-wrap:wrap; align-content:flex-start; color:#333333;}
  .web-cart-list-goods p { width:100%; height:auto; line-height:20px; margin-top:15px; font-size:14px; color:#333333;}
  .web-cart-list-goods a { width:100%; height:auto; line-height:20px; font-size:14px; color:#aaaaaa;}
  .web-cart-list-goods a:hover { color:#aaaaaa;}
  .web-cart-list-props {width:190px; height:auto; line-height:40px; font-size:14px; color:#333333;}
  .web-cart-list-props p { width:90%; height:auto; line-height:20px; margin-top:15px; font-size:14px;  color:rgb(253, 146, 2);}
  .web-cart-list-price {width:120px; height:auto; line-height:80px; font-size:14px; color:#333333;}
  .web-cart-list-price p { width:100%; height:auto; line-height:80px; margin-top:15px; font-size:14px; color:#333333;}
  .web-cart-list-quantity { width:360px; height:auto; text-align: center; justify-content:flex-end; line-height:40px; font-size:14px; color:#333333;}
  .web-cart-list-quantity p { width:136px; height:40px; line-height:40px; overflow: hidden; flex-flow:row; justify-content:flex-start; margin-top:35px; border:1px solid #dfdfdf;}
  .web-cart-list-quantity p a { width: 40px; height: 40px; cursor: pointer; background: #efefef; font-size:28px; color:#333333; line-height:34px; text-align: center; justify-content:center;}
  .web-cart-list-quantity p input { width:55px; height:38px; line-height:38px; text-align: center; font-size:14px; color:#333333; border:0px; min-height: 20px;}
  .web-cart-list-sum { width:120px; height:auto; line-height:40px; font-size:14px; color:#333333;}
  .web-cart-list-sum p { width:100%; height:auto; line-height:20px; margin-top:15px; font-size:14px; color:#333333;}
  .web-cart-list-action { width:100px; height:auto; line-height:40px; text-align: center; justify-content:center; font-size:14px; color:#333333;}
  .web-cart-list-action a { width:100%; height:auto; cursor: pointer; text-align: center; justify-content:center; line-height:20px; margin-top:15px; font-size:14px; color:#333333;}
  .web-cart-list-checkbox { width:110px; height:auto; line-height:40px; font-size:14px; color:#333333;}
  .web-cart-list-checkbox img { width:80px; height:80px; cursor: pointer; margin:15px 0px 15px 15px;}

  .web-order-goods-box { width:100%; height:auto; margin-top:10px; border-top:1px solid #dfdfef; flex-wrap:wrap; align-content:flex-start;}

.web-order-footer { width:100%; height:auto; margin-top:15px;  flex-wrap:wrap; align-content:flex-start;}
    .web-order-footer ul { width:100%; height:auto; margin:0px; padding:0px 15px; flex-wrap:wrap; align-content:flex-start;}
    .web-order-footer ul.money {  height:90px; background: #f4f4f4; padding-top:15px; border-top:1px solid #dfdfdf;}
    .web-order-footer ul li { width:100%; height:30px;margin:0px; padding:0px;justify-content:flex-end;}
    .web-order-footer ul li p { width:70px; height:30px;margin:0px; padding:0px; line-height:30px; color:#333333; font-size:14px;}
    .web-order-footer ul li a { min-width:120px; height:30px; line-height:30px; color:#333333; font-size:14px; text-align: right; justify-content:flex-end;}
    .web-order-footer ul li a option { line-height: 24px;}
    .web-order-footer ul li img { width:18px; height:18px; margin:5px;}
    .web-order-footer ul li a:hover { color:#333333;}
    .web-order-footer ul li a span { color:#999999; margin-left:5px;}
    .web-order-footer ul li a span.select { color:#E6A23C;}
    .web-order-footer ul li a.red { color:#d81e06; font-size:18px; font-weight: bold;}
    .web-order-footer h2 { width:100%; height:50px; margin-top:15px; justify-content:flex-end;}
    .web-order-footer h2 a {width:180px; height:50px; cursor: pointer; line-height:50px; border-radius: 4px; text-align: center; justify-content:center; background: #d81e06; font-size:18px; color:#ffffff;}
    .web-order-footer h2 a:hover { color:#ffffff;}

#textarea { font-size:14px;}

.app_order_select { width:80px;font-size:14px; text-align: right;}

  .web-address-list { width:100%; height:auto; flex-wrap:wrap; align-content:flex-start; border-top:1px solid #dfdfdf;}
    .web-address-list h2 { width:100%; height:30px; line-height: 30px; margin-top:20px; font-size:14px; font-weight: bold; color:#333333;}
    .web-address-list ul { width:100%; height:auto; flex-wrap:wrap; padding:0px; margin:0px; list-style: none; align-content:flex-start;}
      .web-address-list ul li { width:100%; height:auto; cursor: pointer; position: relative; margin-top:10px; flex-wrap:wrap; align-content:flex-start; border:1px solid #dfdfdf; padding:10px;}
        .web-address-list ul li h2 { width:100%; height:30px; line-height: 30px; margin:0px; font-weight: normal; border:0px; font-size:12px; color:#333333;}
        .web-address-list ul li p { width:100%; height:auto; line-height: 20px; margin:0px; font-size:12px; color:#333333;}
        .web-address-list ul li.select { border:1px solid #d81e06;}
        .web-address-list ul li a { position: absolute; display: none; top:15px; right:15px; font-size:32px; color:#d81e06;}
        .web-address-list ul li.select a { display: block;}

    .web-pay-select-box { width:100%; height:auto; margin-top:10px;}
    .web-pay-select-box ul { width:100%; height:auto; list-style: none; flex-wrap:wrap; align-content:flex-start; margin:0px; padding:0px;}
    .web-pay-select-box ul li { width:150px; height:50px; cursor: pointer; border-radius: 3px; padding:10px 20px; box-sizing: border-box; border:2px solid #efefef; margin-right:10px;}
    .web-pay-select-box ul li img { width:30px; height:30px; margin-right:10px;}
    .web-pay-select-box ul li p { width:80px; height:30px; line-height: 30px; font-size:14px; color:#333333;}
    /* .web-pay-select-box ul li:hover { border:2px solid #d81e06;} */
    .web-pay-select-box ul li.select { border:2px solid #d81e06;}
</style>



// WEBPACK FOOTER //
// src/pages/cart/order_submit.vue